module.exports = __webpack_public_path__ + "static/img/Adam-Doueihi.d562834.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Adam-Doueihi.jpg
// module id = yQjZ
// module chunks = 0